/* ============================================================
   Bois & Merveilles - Theme JS
   ============================================================ */
(function () {
  'use strict';

  const moneyFormat = (window.BM && window.BM.moneyFormat) || '€{{amount_with_comma_separator}}';

  function formatMoney(cents) {
    const amount = (Math.round(cents) / 100);
    const decimal = amount.toFixed(2);
    const [intPart, fracPart] = decimal.split('.');
    const withSpaces = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    const commaFormat = withSpaces + ',' + fracPart;
    const dotFormat = withSpaces + '.' + fracPart;
    const noDecimalsComma = withSpaces;
    return moneyFormat
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, commaFormat)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, noDecimalsComma)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDecimalsComma)
      .replace(/\{\{\s*amount\s*\}\}/g, dotFormat);
  }

  async function refreshCart() {
    try {
      const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      const cart = await res.json();
      document.querySelectorAll('[data-cart-count]').forEach((node) => {
        node.textContent = cart.item_count;
        node.hidden = cart.item_count === 0;
      });
      document.dispatchEvent(new CustomEvent('bm:cart:updated', { detail: cart }));
      return cart;
    } catch (e) {
      console.error('cart refresh failed', e);
    }
  }

  async function ajaxAdd(form, btn) {
    const formData = new FormData(form);
    const original = btn ? btn.innerHTML : null;
    if (btn) { btn.disabled = true; btn.innerHTML = '…'; }
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { Accept: 'application/json' },
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || 'Erreur panier');
      await refreshCart();
      if (btn) {
        btn.innerHTML = original;
        btn.disabled = false;
      }
      document.dispatchEvent(new CustomEvent('bm:cart:added', { detail: data }));
    } catch (err) {
      console.error(err);
      if (btn) { btn.disabled = false; btn.innerHTML = original; }
      alert(err.message || 'Erreur, réessayez');
    }
  }

  function initSteppers(root) {
    (root || document).querySelectorAll('[data-stepper]').forEach((wrap) => {
      if (wrap._bound) return;
      wrap._bound = true;
      const input = wrap.querySelector('input[type="number"]');
      if (!input) return;
      const min = parseInt(input.getAttribute('min') || '1', 10);
      const max = parseInt(input.getAttribute('max') || '99', 10);
      const dec = wrap.querySelector('[data-stepper-dec]');
      const inc = wrap.querySelector('[data-stepper-inc]');
      if (dec) dec.addEventListener('click', () => {
        input.value = Math.max(min, parseInt(input.value || '1', 10) - 1);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      if (inc) inc.addEventListener('click', () => {
        input.value = Math.min(max, parseInt(input.value || '1', 10) + 1);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      input.addEventListener('change', () => {
        const v = parseInt(input.value || '1', 10);
        if (isNaN(v) || v < min) input.value = min;
        if (v > max) input.value = max;
      });
    });
  }

  function initAccordions(root) {
    (root || document).querySelectorAll('[data-accordion]').forEach((group) => {
      if (group._bound) return;
      group._bound = true;
      group.querySelectorAll('[data-accordion-btn]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const item = btn.closest('[data-accordion-item]');
          const open = item.dataset.open === 'true';
          group.querySelectorAll('[data-accordion-item]').forEach((other) => {
            other.dataset.open = 'false';
            const sign = other.querySelector('[data-accordion-sign]');
            if (sign) sign.textContent = '+';
            const panel = other.querySelector('[data-accordion-panel]');
            if (panel) panel.hidden = true;
            const b = other.querySelector('[data-accordion-btn]');
            if (b) b.setAttribute('aria-expanded', 'false');
          });
          if (!open) {
            item.dataset.open = 'true';
            const sign = item.querySelector('[data-accordion-sign]');
            if (sign) sign.textContent = '–';
            const panel = item.querySelector('[data-accordion-panel]');
            if (panel) panel.hidden = false;
            btn.setAttribute('aria-expanded', 'true');
          }
        });
      });
    });
  }

  function initRails() {
    document.querySelectorAll('[data-rail]').forEach((wrap) => {
      if (wrap._bound) return;
      wrap._bound = true;
      const rail = wrap.querySelector('[data-rail-track]');
      const prev = wrap.querySelector('[data-rail-prev]');
      const next = wrap.querySelector('[data-rail-next]');
      const step = 298;
      if (prev) prev.addEventListener('click', () => rail.scrollBy({ left: -step, behavior: 'smooth' }));
      if (next) next.addEventListener('click', () => rail.scrollBy({ left: step, behavior: 'smooth' }));
    });
  }

  function initAnnouncement() {
    document.querySelectorAll('[data-announcement]').forEach((bar) => {
      if (bar._bound) return;
      bar._bound = true;
    });
  }

  function initSearch() {
    document.querySelectorAll('[data-search-toggle]').forEach((btn) => {
      if (btn._bound) return;
      btn._bound = true;
      btn.addEventListener('click', () => {
        const panelId = btn.getAttribute('aria-controls');
        const panel = panelId ? document.getElementById(panelId) : document.querySelector('[data-search-panel]');
        if (!panel) return;
        const willOpen = !panel.classList.contains('is-open');
        panel.classList.toggle('is-open', willOpen);
        panel.hidden = !willOpen;
        document.querySelectorAll('[data-search-toggle]').forEach((b) => b.setAttribute('aria-expanded', willOpen ? 'true' : 'false'));
        if (willOpen) {
          const input = panel.querySelector('[data-search-input]');
          if (input) setTimeout(() => input.focus(), 50);
        }
      });
    });
    document.querySelectorAll('[data-search-close]').forEach((btn) => {
      if (btn._bound) return;
      btn._bound = true;
      btn.addEventListener('click', () => {
        const panel = btn.closest('[data-search-panel]');
        if (panel) { panel.classList.remove('is-open'); panel.hidden = true; }
        document.querySelectorAll('[data-search-toggle]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
      });
    });
    if (!document._bmSearchEscBound) {
      document._bmSearchEscBound = true;
      document.addEventListener('keydown', (e) => {
        if (e.key !== 'Escape') return;
        document.querySelectorAll('[data-search-panel].is-open').forEach((panel) => {
          panel.classList.remove('is-open');
          panel.hidden = true;
        });
        document.querySelectorAll('[data-search-toggle]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
      });
    }
  }

  function initMenu() {
    const toggle = document.querySelector('[data-menu-toggle]');
    const nav = document.querySelector('[data-menu]');
    const scrim = document.querySelector('[data-menu-scrim]');
    const closeBtn = document.querySelector('[data-menu-close]');
    if (!toggle || !nav || toggle._bound) return;
    toggle._bound = true;

    function openMenu() {
      nav.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      if (scrim) {
        scrim.hidden = false;
        requestAnimationFrame(() => scrim.classList.add('is-open'));
      }
      document.body.classList.add('bm-nav-locked');
    }

    function closeMenu() {
      nav.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      if (scrim) {
        scrim.classList.remove('is-open');
        setTimeout(() => { if (!scrim.classList.contains('is-open')) scrim.hidden = true; }, 250);
      }
      document.body.classList.remove('bm-nav-locked');
    }

    toggle.addEventListener('click', () => {
      if (nav.classList.contains('is-open')) closeMenu(); else openMenu();
    });
    if (closeBtn) closeBtn.addEventListener('click', closeMenu);
    if (scrim) scrim.addEventListener('click', closeMenu);
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && nav.classList.contains('is-open')) closeMenu();
    });
  }

  function initProduct() {
    const root = document.querySelector('[data-product]');
    if (!root || root._bound) return;
    root._bound = true;

    const dataEl = root.querySelector('[data-product-json]');
    if (!dataEl) return;
    let product;
    try { product = JSON.parse(dataEl.textContent); } catch (e) { return; }

    const form = root.querySelector('[data-product-form]');
    const variantInput = root.querySelector('[data-variant-id]');
    const priceEl = root.querySelector('[data-product-price]');
    const compareEl = root.querySelector('[data-product-compare]');
    const atc = root.querySelector('[data-atc]');
    const galleryMain = root.querySelector('[data-gallery-main] img');

    const optionInputs = Array.from(root.querySelectorAll('[data-option-input]'));

    function getSelectedOptions() {
      const opts = [];
      const grouped = {};
      optionInputs.forEach((input) => {
        if (input.checked) grouped[input.name] = input.value;
      });
      Object.keys(grouped).sort().forEach((k) => opts.push(grouped[k]));
      return opts;
    }

    function findVariant(selected) {
      if (optionInputs.length === 0) {
        return product.variants[0];
      }
      return product.variants.find((v) => {
        return v.options.every((opt, i) => opt === selected[i]);
      });
    }

    function updateAvailability(selected) {
      if (optionInputs.length === 0) return;
      const groups = {};
      optionInputs.forEach((input) => {
        if (!groups[input.name]) groups[input.name] = [];
        groups[input.name].push(input);
      });
      Object.keys(groups).forEach((name) => {
        const idx = parseInt(name.replace('option', ''), 10) - 1;
        groups[name].forEach((input) => {
          const trial = selected.slice();
          trial[idx] = input.value;
          const match = product.variants.find((v) => v.options.every((opt, i) => trial[i] === undefined || trial[i] === opt));
          const label = input.parentElement.querySelector('.bm-product__option-label-pill');
          if (!match || !match.available) {
            if (label) label.classList.add('bm-product__option-label-pill--soldout');
          } else {
            if (label) label.classList.remove('bm-product__option-label-pill--soldout');
          }
        });
      });
    }

    function setVariant(variant) {
      if (!variant) {
        if (atc) {
          atc.disabled = true;
          atc.textContent = 'Indisponible';
        }
        if (variantInput) variantInput.value = '';
        return;
      }
      if (variantInput) variantInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = formatMoney(variant.compare_at_price);
          compareEl.hidden = false;
        } else {
          compareEl.textContent = '';
          compareEl.hidden = true;
        }
      }
      if (atc) {
        if (variant.available) {
          atc.disabled = false;
          atc.textContent = 'Ajouter au panier';
        } else {
          atc.disabled = true;
          atc.textContent = 'Rupture de stock';
        }
      }
      if (galleryMain && variant.featured_image && variant.featured_image.src) {
        galleryMain.src = variant.featured_image.src;
        galleryMain.alt = variant.featured_image.alt || product.title;
      }
      try {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) { /* noop */ }
    }

    function onChange() {
      const selected = getSelectedOptions();
      const variant = findVariant(selected);
      updateAvailability(selected);
      setVariant(variant);
    }
    optionInputs.forEach((input) => input.addEventListener('change', onChange));
    onChange();

    if (form) {
      form.addEventListener('submit', (e) => {
        e.preventDefault();
        ajaxAdd(form, atc);
      });
    }
  }

  function initGallery() {
    document.querySelectorAll('[data-gallery]').forEach((g) => {
      if (g._bound) return;
      g._bound = true;
      const main = g.querySelector('[data-gallery-main] img');
      g.querySelectorAll('[data-gallery-thumb]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const src = btn.getAttribute('data-src');
          const alt = btn.getAttribute('data-alt') || '';
          if (main && src) {
            main.src = src;
            main.alt = alt;
          }
          g.querySelectorAll('[data-gallery-thumb]').forEach((b) => b.setAttribute('aria-current', 'false'));
          btn.setAttribute('aria-current', 'true');
        });
      });
    });
  }

  function initCardAdds() {
    document.querySelectorAll('[data-card-add]').forEach((btn) => {
      if (btn._bound) return;
      btn._bound = true;
      btn.addEventListener('click', async (e) => {
        e.preventDefault();
        const id = btn.getAttribute('data-variant-id');
        if (!id) return;
        const fd = new FormData();
        fd.append('id', id);
        fd.append('quantity', '1');
        try {
          btn.disabled = true;
          const res = await fetch('/cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } });
          if (!res.ok) throw new Error('Erreur panier');
          const data = await res.json();
          await refreshCart();
          document.dispatchEvent(new CustomEvent('bm:cart:added', { detail: data }));
        } catch (err) {
          console.error(err);
          alert('Erreur, réessayez');
        } finally {
          btn.disabled = false;
        }
      });
    });
  }

  function boot() {
    initSteppers();
    initAccordions();
    initRails();
    initAnnouncement();
    initSearch();
    initMenu();
    initProduct();
    initGallery();
    initCardAdds();
    refreshCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.BM = Object.assign(window.BM || {}, {
    refreshCart,
    initAll: boot,
  });
  document.addEventListener('shopify:section:load', boot);
})();
